import { useState } from 'react';
import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// import { MenuItem } from '@mui/material';
import BasePrimaryNavItem from './BasePrimaryNavItem';
import ExcelUploadModal from 'src/components/order/ExcelUploadModal';

declare interface Props {
  isPopover?: boolean;
}

const CustomerItem: FC<React.PropsWithChildren<Props>> = (props) => {
  const [open, setOpen] = useState<boolean>(false);
  const [uploadItemsOpen, setUploadItemsOpen] = useState(false);
  const enableNewPerfectOrder = import.meta.env.REACT_APP_ENABLE_NEW_PERFECT_ORDER === 'true';

  const menu = {
    section: 'Sales Rep',
    items: [
      {
        title: 'Analytics',
        path: '/sales/Analytics',
      },
      {
        title: 'Orders',
        path: '/sales/ViewOrders',
      },
      ...(enableNewPerfectOrder
        ? [
            {
              title: 'Perfect Orders',
              path: '/sales/PerfectOrders',
            },
          ]
        : []),
      {
        title: 'All Activities',
        path: '/activity/AllActivities',
      },
      {
        title: 'Max Discounts',
        path: '/sales//maxDiscounts',
      },
      {
        title: 'My Customers',
        path: '/myCustomers',
      },
      {
        title: 'Smart Connect',
        path: '//www.bfgsupply.com/MyAccount/Profile',
        type: 'external',
      },
      {
        title: 'Upload Excel Order',
        path: window.location.pathname,
      },
    ],
  };

  const handleClose = (title: string) => {
    if (title === 'Upload Excel Order') setUploadItemsOpen(true);
    setOpen(!open);
  };

  const content = (
    <>
      <p className="global-nav__section-title">{menu.section}</p>
      <div className="global-nav__item">
        {menu.items.map((item, index) => {
          return (
            <div className="global-nav__item-link" key={index}>
              {item.type === 'external' ? (
                <a href={item.path} key={index} target="_blank">
                  {item.title}
                </a>
              ) : (
                <RouterLink to={item.path} key={index} onClick={() => handleClose(item.title)}>
                  {item.title}
                </RouterLink>
              )}
            </div>
          );
        })}
      </div>
    </>
  );

  return (
    <BasePrimaryNavItem anchorEl={menu.section} isPopover={props.isPopover} isOpen={open}>
      {content}
      <ExcelUploadModal open={uploadItemsOpen} onClose={() => setUploadItemsOpen(false)} title="Upload Excel Order" isExcelOrder={true} />
    </BasePrimaryNavItem>
  );
};

export default CustomerItem;
